<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{currentSession.event && currentSession.event.name}}</h2>
			<i>{{prettyDate}}</i>
			<p>{{properties.plaintext && properties.plaintext[lang]}}</p>
			<ul v-if="properties.fields">
				<li v-for="(value, key) in properties.fields">
					<component v-bind:is="value.type+'_input'" v-on:validateField="validateField" v-bind:params="value.params" v-bind:oldValue="oldValue[value.params.name]" v-bind:lang="lang"></component>
				</li>
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{fields[lang].next}}</button>
		</form>
	<div id="overlay-popup" v-on:click="conditions()"></div>
	</main>
</template>

<script>
//Input components
import text_input from '@/components/candidate_forms/text_input.vue';
import date_input from '@/components/candidate_forms/date_input.vue';
import empty_input from '@/components/candidate_forms/empty_input.vue';
import mail_input from '@/components/candidate_forms/mail_input.vue';
import number_input from '@/components/candidate_forms/number_input.vue';
import jobType_input from '@/components/candidate_forms/jobType_input.vue';
import radio_input from '@/components/candidate_forms/radio_input.vue';
import radio_mobility_input from '@/components/candidate_forms/radio_mobility_input.vue';
import phone_input from '@/components/candidate_forms/phone_input.vue';
import checkbox_input from '@/components/candidate_forms/checkbox_input.vue';
import select_checkbox_input from '@/components/candidate_forms/select_checkbox_input.vue';
import pools_checkbox_input from '@/components/candidate_forms/pools_checkbox_input.vue';


import lib from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.properties || !scope.properties.fields || !Array.isArray(scope.properties.fields)) return false;
	return scope.properties.fields.every(field => {
		if(!field.params.compulsory) return true;
		return scope.answer[field.params.name];
	});

}
export default {
	name: 'candidate2Tpl',
	data() {
		return {
			loading : false,
			oldValue : {},
			answer : {},
			fields : {
				fr : {

					next : 'Valider'
				},
				en : {

					next : 'Next'
				}
			},
			isActive : false
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		text_input, date_input, mail_input, number_input, radio_input, jobType_input, phone_input, radio_mobility_input, checkbox_input,select_checkbox_input,empty_input, pools_checkbox_input
	},
	computed : {
		prettyDate : function(){
			return lib.prettyDate(this.lang, 'text');
		},
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			let out = {consent : this.consent};
			this.properties.fields.forEach( field => {
				if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
			});
			this.$emit('validateStep', this.$options.name, out);
		},
		conditions: function(){
			event.preventDefault();
			var popup = document.getElementById("popup");
			var overlay = document.getElementById("overlay-popup");
			if(!popup.classList.length){
				popup.classList.add("selected");
				overlay.classList.add("selected");
			} else {
				popup.classList.remove("selected");
				overlay.classList.remove("selected");
			}
		},
		validateConditions: function(){
			document.getElementById("popup").classList.remove("selected");
			document.getElementById("overlay-popup").classList.remove("selected");
			this.consent = true;
		},
		getLabel : componentTools.getLabel,
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		}

	},
	watch: {
		currentSession : {
			handler : function(val){
				let candidateTplRes = val.stepsResults && val.stepsResults[this.$options.name + '_' + this.templateIndex];
				if(!candidateTplRes){
					this.consent = false;
					Object.keys(this.answer).forEach(k => this.$set(this.oldValue, k, null)); //cf vue reactivity for binded object properties
					this.answer = {};
				}
			},
			deep : true,


		},
		consent : function(val){
			this.isActive = checkForm(this);
		}
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		if(oldRes) this.oldValue = oldRes;
	},
	mounted : function(){
		this.$nextTick(function () {
			lib.pattern_icon();
		});
	}
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}
 #conditionsChoice{
	width: 85%;
	text-align: left;
	label{
		padding: 0;
		position: relative !important;
		display: inline-block;
		max-width: 75% !important;
		vertical-align: top;
		text-align: left;
		font-size: 16px;
		span {
			text-decoration: underline;
			color: blue;
			cursor: pointer;
		}
	}
	&[type="checkbox"]{
		margin: 0;
		position: relative;
		vertical-align: middle;
	}
}
#form #select_checkbox_input #select_box {
	width: 50%;
	margin-left: 50%;
	&.active {
		select {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}
		&+ ul {
			display: block;
		}
	}
}

#form #select_checkbox_autocomplete_input #select_box {
	width: 50%;
	margin-left: 50%;
	&.active {
		select {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}
		&+ ul {
			display: block;
		}
	}
}
#form #select_checkbox_input #select_box select,#form #select_checkbox_autocomplete_input #select_box select{
	width: 100%;
}

#form {
	.empty_space{
		height:40px;
	}

}

#form #select_checkbox_input #select_box #over_select {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}
#form #select_checkbox_input ul {
	width: 50%;
	display: none;
	max-height: 30vh;
	overflow-y: auto;
	margin-left: 50%;
	padding: 10px;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}
#form #select_checkbox_input ul li {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
}
#form #select_checkbox_input ul li label {
	text-align: left;
	max-width: 70% !important;
	position: relative;
}

#form #select_checkbox_autocomplete_input ul {
	width: 50%;
	display: none;
	max-height: 30vh;
	overflow-y: auto;
	margin-left: 50%;
	padding: 10px;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}
#form #select_checkbox_autocomplete_input ul li {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
}
#form #select_checkbox_autocomplete_input ul li label {
	text-align: left;
	max-width: 70% !important;
	position: relative;
}


#form #jobTypeChoice {
	margin-left: 50%;
	text-align: left;
}
#form #jobTypeChoice li {
	display: inline-block;
	vertical-align: top;
	max-width: 200px;
	padding-right: 4%;
	margin-top: 0;
	margin-bottom: 0;
	&:last-of-type {
		clear: both;
	}
	input{
		display: inline-block;
		text-align: left;
		&:first-of-type{
			margin-left: 0;
		}
	}
	label{
		position: relative;
		top: -4px;
		vertical-align: middle;
		margin-left: 0;
		padding: 0;
		&:last-of-type{
			margin-right: 0;
		}
		cursor : pointer;
	}
}
#form #gender li label {
	width: 60px !important;
	text-align: left;
}

#form{
	empty_input {
		margin:1px;
	}
}
#form #gender, #form #mobility {
	.label_radio {
		position: absolute;
		left: 0;
		top: 0;
		margin: 0;
	}
	.template_input {
		text-align: right;
		margin: 0 0 0 50%;
		width: 50%;
		position: relative;
		display: inline-block;
	}
	li {
		text-align: left;
		padding-left: 4%;
		margin: 0;
		display: inline-block;
	}
	li#add_localization {
		padding-left: 0;
		margin-top: 10px;
		display: none;
	}
	li#add_localization.display {
		display: block;
	}
	input {
		display: inline-block;
	}
	input[type="text"] {
		width: 100%;
		margin-left: 0;
	}
	label {
		position: relative;
	}
}
#popup {
	display: none;
	border-radius: 10px;
	padding: 2% 4% 2% 4%;
	z-index: 3;
	background-color: @cWhite;
	box-shadow: 0px -0px 5px 5px rgba(23, 23, 23, 0.2); // cGrey
	position: absolute;
	transform: translate(-50%, -50%);
	left: 50%;
	top: 50%;
	text-align: justify;
	button {
		position: relative;
		left: 50%;
		transform: translate(-50%, 0%);
	}
}
#popup.selected {
	display: block;
}
#overlay-popup {
	display: none;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	opacity: 0.5;
	width: 100%;
	height: 100vh;
	background-color: @cGrey;
}
#overlay-popup.selected {
	z-index: 3;
	display: block;
}
// Computer
@media screen
and (min-width: 1025px){
	#form #jobTypeChoice li{
		input {
			margin-left: -5%;
		}
		label{
			margin-right: 15%;
			font-size: 18px;
		}
	}
}
// Small computer
@media screen
and (max-width: 1024px)
and (min-width: 769px){
	#form #jobTypeChoice {
		input {
			margin-left: -5%;
		}
		label:not(:first-of-type){
			font-size: 1.8vw;
			margin-right: 15%;
		}
	}
}
// Tablet
@media screen
and (max-width: 768px)
and (min-width: 481px){
	#form #conditionsChoice{
		label{
			font-size: 12px;
		}
	}
	#form #jobTypeChoice{
		input {
			margin-left: -5%;
		}
		label:not(:first-of-type){
			font-size: 2.6vw;
			margin-right: 9%;
		}
	}
}
// Smartphone
@media screen
and (max-width: 480px){
	#form #conditionsChoice{
		label{
			font-size: 10px;
		}
	}
	#form #jobTypeChoice{
		margin-left: 50%;
		input {
			margin-left: -0%;
		}
		label:not(:first-of-type){
			font-size: 3vw;
			margin-right: 4%;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/candidate2.vue